module.exports = __webpack_public_path__ + "static/media/2.a49cb401.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/2.jpg
// module id = 13605
// module chunks = 0